import { Base } from "../../framework/base";

export interface DateItem {
    dateString: string;
    localizedDateString: string;
}

const getShortTime = () =>
    new Intl.DateTimeFormat(appConfig.culture ?? "fi", {
        weekday: "short",
        day: "numeric",
        month: "numeric",
    });

function getDateItem(date: string): DateItem {
    return {
        dateString: date,
        localizedDateString: Base.capitalizeFirstChar(
            getShortTime().format(new Date(date))
        ),
    };
}

export function getDateItemsForRange(start: string, end: string): DateItem[] {
    return getDatesForRange(start, end).map(getDateItem);
}

export function getDatesForRange(
    start: string | undefined,
    end: string | undefined
) {
    if (typeof start === "undefined" || typeof end === "undefined") {
        return [];
    }
    const dates: string[] = [];
    const endDate = end;
    let currentDate = Base.dateStartOf(start, "day");
    while (Base.isSameOrBefore(currentDate, endDate, "day")) {
        dates.push(Base.dayjsToJsonDate(currentDate));
        currentDate = Base.dateAddDays(currentDate, 1);
    }
    return dates;
}
